import { customizeTargetTrackingData } from './tracking';
import { useCustomization } from './useCustomization';

export const useCustomizeTargetTracking = () => {
  const { targetImage } = useCustomization();

  return customizeTargetTrackingData(targetImage);
};
